import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId", "description", "sideContent", "children"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { hasReactChildren } from 'utils/ui';
import { BASIC } from 'styles/spacingPresets';
import Card from 'components/Card';
import Divider from 'components/Divider';
import Flex, { Box } from 'components/Flex';
import Heading from 'components/Heading';
import Text from 'components/Text';
import Disclosure from 'components/Disclosure';
import useUniqueId from 'hooks/useUniqueId';
export function TitleCardWithToggle(_ref) {
  var title = _ref.title,
    titleStringId = _ref.titleId,
    description = _ref.description,
    sideContent = _ref.sideContent,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var titleId = useUniqueId(titleStringId);
  var hasChildren = hasReactChildren(children);
  return /*#__PURE__*/React.createElement(Disclosure.Provider, null, /*#__PURE__*/React.createElement(Card, _extends({
    role: "region",
    "aria-labelledby": titleId,
    px: BASIC.LARGE,
    py: BASIC.MEDIUM,
    breakpoints: BASIC.BREAKPOINTS
  }, otherProps), /*#__PURE__*/React.createElement(Flex, {
    wrap: true,
    alignItems: "baseline",
    gap: "xxs"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true
  }, /*#__PURE__*/React.createElement(Disclosure.Toggle, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    mr: "auto",
    id: titleId
  }, title), Boolean(description) && /*#__PURE__*/React.createElement(Text, {
    as: "p",
    size: "s",
    mt: "xxs"
  }, description))), Boolean(sideContent) && /*#__PURE__*/React.createElement(Box, null, sideContent)), /*#__PURE__*/React.createElement(Disclosure.Hidden, null, hasChildren && /*#__PURE__*/React.createElement(Divider, {
    my: "m"
  }), children)));
}